import { useCallback } from "react";
import "./i18n"; // ensure the shared instance is initialised before first use
import { useTranslation } from "react-i18next";

// Returns `t(key, options?)` bound to the active language; re-renders consumers on
// a language change. Keys are dot-namespaced (nested in the JSON catalogs), e.g.
// t("nav.favourites"). Interpolation/plurals use i18next syntax:
//   t("shopping.itemsToBuy", { count: 3 })  →  "3 items" / "3 artículos" …
// with catalog entries "…_one" / "…_other" and "{{count}}" placeholders.
//
// The returned function is stable across renders (keyed on the underlying i18next
// `t`, which only changes on a language switch) so callers can safely list it in
// useMemo/useCallback dependency arrays without busting the memo every render.
export function useT(): (key: string, options?: Record<string, unknown>) => string {
  const { t } = useTranslation();
  return useCallback(
    (key, options) => t(key, options ?? {}) as string,
    [t],
  );
}
